module.exports = __webpack_public_path__ + "img/map-djzy1.b167f949.png";